// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DOCGRIDROUTES from "../../docRoutes/docRoutes";
import bdLogo from "../../assets/img/kairausNew.svg";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import AddIcon from "@mui/icons-material/Add";
import ListIcon from "@mui/icons-material/List";
import SummarizeIcon from "@mui/icons-material/Summarize";
import ShareIcon from "@mui/icons-material/Share";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import { UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Space, Divider, Button, Tooltip, theme } from "antd";
import AppsIcon from "@mui/icons-material/Apps";
import { DashboardOne, SettingTwo, DocumentFolder, AddOne, ViewList, ShareOne, UserBusiness } from "@icon-park/react";
// images
import profileImg from "../../assets/img/profile.png";
import SettingImg from "../../assets/img/setting.png";
import logoutImg from "../../assets/img/logout.png";
import briefcaseImg from "../../assets/img/archive.png";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { userLogoutAction } from "../../Redux/actions/authAction";
import { useDispatch } from "react-redux";
import ROUTES from "../../docRoutes/docRoutes";
// import { LogoApi } from "Services/bidgrid/master/company Logo/bidLogo";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import DefaultImage from "../../assets/img/profile.jpg";
import dayjs from "dayjs";
import { DocImgBaseUrl } from "../../utils/configurable";
import { useFetch } from "../../Services/useFetch";
import { fetchAuthMode, ssoAppsUrl } from "../../utils/docGridSso";
const { useToken } = theme;

function useScrollDirection() {
  const [scrollDirection, setScrollDirection] = useState(null);
  useEffect(() => {
    let lastScrollY = window.pageYOffset;
    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset;
      const direction = scrollY > lastScrollY ? "down" : "up";
      if (direction !== scrollDirection && (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)) {
        setScrollDirection(direction);
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };
    window.addEventListener("scroll", updateScrollDirection); // add event listener
    return () => {
      window.removeEventListener("scroll", updateScrollDirection); // clean up
    };
  }, [scrollDirection]);

  return scrollDirection;
}

const arr = [];

const DocHeader = () => {
  const location = useLocation();
  const scrollDirection = useScrollDirection();
  const path = location.pathname;
  const { userInfo } = useSelector((state) => state.userDetails);
  // const { companydetails } = useSelector((state) => state?.companyData)
  const [notificationHistory, setNotificationHistory] = useState([]);
  const [logo, setLogo] = useState();
  //notification states
  const [notification, setNotification] = useState([]);
  const [designation, setDesignation] = useState();

  const dispatch = useDispatch();
  const [menuList, setMenuList] = useState({
    master: false,
    add: false,
    profile: false,
  });
  const [activeMenu, setActiveMenu] = useState(localStorage.getItem("activeItem") || null);

  const [overlayShow, setOverlayShow] = useState(false);
  // "All apps" opens the central login's applications page (idp mode only).
  const [isIdpMode, setIsIdpMode] = useState(false);

  useEffect(() => {
    fetchAuthMode().then((mode) => setIsIdpMode(mode === "idp"));
  }, []);

  const { request } = useFetch();

  const CompanyLogo = async () => {
    try {
      // const response = await LogoApi.getLogo()
      const response = await request("/get-company-logo", "get", null, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status == 1) {
        setLogo(response?.data?.data);
        // setLogo({ docname: response?.data?.data?.logo_file_name, docpath: response?.data?.data?.logo_file_path, })
      } else {
        // notify(response?.response?.data?.message)
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("docGridToken")) {
      CompanyLogo();
    }
  }, [localStorage.getItem("docGridToken")]);

  const handleMenu = (e, name) => {
    setMenuList({
      master: name === "master" ? !menuList.master : false,
      add: name === "add" ? !menuList.add : false,
      profile: name === "profile" ? !menuList.profile : false,
    });
    setActiveMenu(name);
    localStorage.setItem("activeItem", name);
  };

  useEffect(() => {
    if (menuList.master === true || menuList.add === true || menuList.profile === true) {
      setOverlayShow(true);
    } else {
      setOverlayShow(false);
    }
  }, [menuList]);

  const handleClickOutside = (e) => {
    const headerLastElement = document.getElementsByClassName("bd_profileMenu")[0];
    const headerMasterElement = document.getElementsByClassName("Master_menu")[0];
    const headerAddElement = document.getElementsByClassName("Add_menu")[0];

    if (
      (!headerLastElement || !headerLastElement.contains(e.target)) &&
      (!headerMasterElement || !headerMasterElement.contains(e.target)) &&
      (!headerAddElement || !headerAddElement.contains(e.target))
    ) {
      setMenuList({
        master: false,
        add: false,
        profile: false,
      });
      setOverlayShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const storedActiveItem = localStorage.getItem("activeItem");
    if (storedActiveItem) {
      setActiveMenu(storedActiveItem);
    }
  }, []);

  useEffect(() => {
    let pathname = window.location.pathname.split("/")[2];
    setActiveMenu(pathname);
  }, [window.location.pathname]);

  const handleLogout = () => {
    dispatch(userLogoutAction({ global: true }));
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };
  const scrollToBottom = () => {
    const targetPosition = Math.max(0, document.documentElement.scrollHeight - window.innerHeight - 0);

    window.scroll({
      top: targetPosition,
      behavior: "smooth",
    });
  };

  // const handleNavigate = async (item) => {
  //   if (item.category_types === 'tender_todo_comments' || item.category_types === 'tender_comments' || item.category_types === 'meeting_schedule' || item.category_types === 'tender_request') {
  //     let str = ROUTES.BD_TENDERDETAILS.replace(':id', item?.tender_id)
  //     navigate(str, { state: { key: item?.category_id, type: item.category_types, item: item } });
  //   } else if (item.category_types === 'to_do_comments') {
  //     navigate('/bidgrid/todo', { state: { key: item?.category_id, item: item } });
  //   }
  //   try {
  //     const formData = new URLSearchParams()
  //     formData.append('notification_id', item?.id)
  //     // const response = await DashboardServiceApi.notificationSeen(formData)
  //     if (response?.data?.status === '1') {
  //       getUserHistoryApi()
  //     }
  //   } catch (error) {

  //   }

  // }

  function convertHtmlToText(item) {
    return item?.replace(/<[^>]*>/g, "");
  }

  // const getUserHistoryApi = async () => {
  //   try {
  //     const response = await DashboardServiceApi.fetchNotifications()
  //     if (response?.data?.status === '1') {
  //       setNotification(response?.data?.data)
  //     } else {
  //       setNotification([])
  //     }
  //   } catch (error) {
  //     setNotification([])
  //   }
  // }

  const { token } = useToken();
  const contentStyle = {
    backgroundColor: token.colorBgElevated,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadowSecondary,
  };
  const menuStyle = {
    boxShadow: "none",
  };

  return (
    <>
      <div
        className="bd_topScoll"
        onClick={scrollToTop}
        style={{ display: scrollDirection === "down" ? "flex" : "none" }}
      >
        <ArrowUpwardIcon />
      </div>
      <div
        className="bd_downScoll"
        onClick={scrollToBottom}
        style={{ display: scrollDirection === "up" ? "flex" : "none" }}
      >
        <ArrowDownwardIcon />
      </div>
      {path !== ROUTES.LOGIN && (
        <div className="bg_header">
          <div className="bd_brand_img" onClick={(e) => handleMenu(e, "dashboard")}>
            {logo ? (
              <Link to={ROUTES?.BRIEFCASE}>
                <img
                  className="bd_main_sub_s_img"
                  src={`${DocImgBaseUrl}${logo[0]?.path}${logo[0]?.logo}`}
                  width={180}
                />
              </Link>
            ) : (
              <Skeleton width={180} height={50} />
            )}
          </div>
          <div className="Header_center">
            <ul className="mainMenuNew">
              <li className={activeMenu === "master" ? "nav-item Master_menu active" : "nav-item Master_menu "}>
                <div className={menuList.master ? "bg_megamenu Bd_menu_visible" : "bg_megamenu "}></div>
              </li>

              {/* <Link to={BIDGRIDROUTES?.briefcase} className="nav-item">
                <span>
                  <img src={briefcaseImg} style={{ width: 22, opacity: ".6" }} />
                  Briefcase
                </span>
              </Link> */}
            </ul>
          </div>

          {isIdpMode && (
            <Tooltip placement="bottom" title="All apps">
              <a className="bd_appsLauncher" href={ssoAppsUrl} aria-label="All apps">
                <AppsIcon />
              </a>
            </Tooltip>
          )}

          <div className="bd_profileMenu" onClick={(e) => handleMenu(e, "profile")}>
            <div className="bd_userProfile">
              {userInfo?.profileimg ? (
                <img
                  alt=""
                  className="img-thumbnail rounded-circle"
                  src={
                    userInfo?.profileimg !== null
                      ? `${DocImgBaseUrl}${userInfo.profileimg_path}/${userInfo.profileimg}`
                      : DefaultImage
                  }
                />
              ) : (
                <Avatar style={{ width: "40px", height: "40px" }}>
                  {userInfo?.firstname !== null ? userInfo?.firstname?.charAt(0) : userInfo?.userfullname?.charAt(0)}
                </Avatar>
              )}
            </div>
            <div className="bd_para">
              <h4>{userInfo?.userfullname} </h4>
              <p>{designation}</p>
            </div>
            <div style={{ paddingLeft: 10, marginLeft: "auto" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <path
                  d="M5 7.5L10 12.5L15 7.5"
                  stroke="#636363"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className={menuList.profile ? "bg_megamenu Bd_menu_visible" : "bg_megamenu"}>
              <div className="rowGridFlex">
                <div className="megaLink">
                  <Link to={ROUTES?.PROFILE} onClick={(e) => handleMenu(e, "profile")}>
                    <span>
                      <img src={profileImg} alt="" />
                      Profile
                    </span>
                  </Link>
                </div>

                {userInfo?.permanent_sys_adm == "2" ? (
                  <></>
                ) : (
                  <>
                    <div className="megaLink">
                      <Link to={ROUTES?.EMPLOYEE}>
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="18"
                            fill="currentColor"
                            className="bi bi-people"
                            viewBox="0 0 16 16"
                          >
                            <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
                          </svg>{" "}
                          Users
                        </span>
                      </Link>
                    </div>
                    <div className="megaLink">
                      <Link to={ROUTES?.SETTING}>
                        <span>
                          <img src={SettingImg} alt="profileImg" style={{ width: 22, opacity: ".6" }} />
                          Setting
                        </span>
                      </Link>
                    </div>
                  </>
                )}
                <div className="megaLink no-border" onClick={(e) => handleMenu(e, "profile")}>
                  <a>
                    <span onClick={handleLogout}>
                      <img src={logoutImg} alt="" />
                      Logout
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="bd_overly" style={overlayShow ? { display: "block" } : { display: "none" }}></div>
    </>
  );
};
export default DocHeader;
